import { render, staticRenderFns } from "./OtherOfficeMessageReplyInput.vue?vue&type=template&id=6891145a&scoped=true&lang=pug"
import script from "./OtherOfficeMessageReplyInput.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeMessageReplyInput.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeMessageReplyInput.vue?vue&type=style&index=0&id=6891145a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6891145a",
  null
  
)

export default component.exports